export default __webpack_public_path__ + "static/media/telegram-seeklogo.com.feb915a8.svg";